module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAApElEQVRIx2NgMLRimLiKYfVJeiMQYGZh8IlkWLiX7hZDAJ8gQ3olw6rjdLcYAhTUGBqnD4TFEGDpzDBt40BYDASsbAzBSQxLDtDdYjDgFBEwr0oO2zMzbO8s6iIGYoCFEf+xjSa/HjhRETEQCRgZGeJCJB+dtqG3xRDAw83cUq78+ZbDCLB4YIJ6ABLXQGSngSlABqDIHIBKYgCqxYFpCAxQ0wcAfZD/dHeRkMoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/bs.png
// module id = 246
// module chunks = 0